export const FOOTER_LINKS: readonly string[] = Object.freeze([
    "cookies",
    "contract",
    "privacy",
]);
